import process from 'process/browser';
export const minproc = process;